module.exports = __webpack_public_path__ + "img/1-1.6dd20d5b.svg";